import { Toaster as SonnerToaster } from 'sonner';

// Wrapper de Sonner con los tokens de la paleta. Se monta una sola vez en main.tsx.
export function Toaster(): JSX.Element {
  return (
    <SonnerToaster
      position="top-right"
      richColors
      closeButton
      toastOptions={{
        classNames: {
          toast: 'group rounded-md border border-marca-neutro bg-surface text-sm text-marca-gris shadow-md',
          title: 'font-medium',
          description: 'text-marca-gris/70',
        },
      }}
    />
  );
}
